export const ACTIVITY_AGENT_ICONS = {
  Chrome: 'os-icon-browser-chrome',
  Firefox: 'os-icon-browser-firefox',
  Safari: 'os-icon-browser-safari',
  Edge: 'os-icon-browser-edge',

  Windows: 'os-icon-os-windows',
  iOS: 'os-icon-os-apple',
  'Mac OS': 'os-icon-os-apple',

  desktop: 'os-icon-monitor',
  mobile: 'os-icon-tablet'
};
